import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProfileStep from './ProfileStep';

export default class AreYouRetiredStep extends ProfileStep {
  onNext = (e) => {
    e.preventDefault();

    let radioElement = document.getElementById('profile_is_retired_true');
    this.props.stepConfig.isRetiredHandler(radioElement.checked)
    this.props.onNext();
  }

  render() {
    return (
      <div className="profile-step">
        <h1 className="profile-step__title">Let's start planning your retirement</h1>
        <div className="profile-step__content">
          <div className="title-section__additional"><p>Are you already retired?</p></div>
          <form className="simple_form js-onboarding-form onboarding__form" action="/onboarding/profile" acceptCharset="UTF-8" method="post">
            <input name="utf8" type="hidden" value="✓"/>
            <div className="inline-radio">
              <fieldset className="form__inputs">
                <div className="form-input radio_buttons optional profile_is_retired">
                  <fieldset className="form-controls">
                    <legend className="is-hidden form-control__label">
                      <span>Is retired</span>
                    </legend>
                    <div className="form-controls__controls">
                      <input type="hidden" name="profile[is_retired]" value=""/>
                      <label className="form-control" htmlFor="profile_is_retired_true">
                        <input className="radio_buttons optional" type="radio" value="true" defaultChecked={this.props.stepConfig.isRetired} name="profile[is_retired]" id="profile_is_retired_true"/>
                        <span className="form-control__indicator"></span>
                        <span className="form-control__label">Yes</span>
                      </label>
                      <label className="form-control" htmlFor="profile_is_retired_false">
                        <input className="radio_buttons optional" type="radio" value="false" defaultChecked={!this.props.stepConfig.isRetired} name="profile[is_retired]" id="profile_is_retired_false"/>
                        <span className="form-control__indicator"></span>
                        <span className="form-control__label">No</span>
                      </label>
                    </div>
                  </fieldset>
                </div>
              </fieldset>
            </div>
          </form>
          <div className='flex flex-col gap-4 mr-12 xs:mr-auto xs:flex xs:flex-row'>
          { this.props.onNext && <a href="#" className="button profile-step__button qa-profile-are-you-retired" onClick={this.onNext}>Next</a> }
          </div>
        </div>
      </div>
    )
  }
}
